import React from 'react';
import api from '../../assets/icons/api.svg';
import computer from '../../assets/icons/computer.svg'
import repair from '../../assets/icons/repair.svg'
import algo from '../../assets/icons/algo.svg'
import robot from '../../assets/icons/robot.jpg'
const skills =[
    {
        icon:computer,
        title:'Front End Development',
        about:['I can build professional creative and stylish webpages using',<strong key={1}> HTML and CSS.</strong>]
    },
    {
        icon:repair,
        title:'Back End Development',
        about:['I can handle server, database, api with', <strong key={1}> Django and SQL</strong>]
    },
    {
        icon:algo,
        title:'Algo and DS',
        about:['Daily working on improving my problem solving skills on', <strong key={1}> Leetcode and Hackerrank.</strong>]
    },
        {
        icon:robot,
        title:'Software Testing',
        about:['Create and run efficient acceptance test for acceptance based development using', <strong key={1}> RobotFramework.</strong>]
    }
]
export { skills }